
 <!-- 我的信息 -->
<template>
  <div class="app-container">
    <div class="info">
      <div v-if="page==='info'" class="filter-container">
        <el-form
          ref="form"
          :model="info"
          label-width="80px"
        >
          <el-form-item :label="$t('text.yhm')">
            <el-input
              v-model="info.username"
            />
          </el-form-item>
          <el-form-item :label="$t('text.sjhm')">
            <el-input v-model="info.mobile" />
          </el-form-item>
          <el-form-item :label="$t('text.gsmc')">
            <el-input v-model="info.company" />
          </el-form-item>
          <el-form-item :label="$t('text.dzyx')">
            <el-input v-model="info.email" />
          </el-form-item>
          <el-form-item class="text-center">
            <el-button
              plain
              type="primary"
              style="background:#1E9585;border:none;color:#fff"
              @click="onSubmit"
            >{{ $t('button.bc') }}</el-button>
          <!-- <el-button>重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
      <div v-if="page==='logo'" class="filter-container">
        <el-form label-width="80px">
          <el-form-item label="logo">
            <ImgUpload v-model="logo" class="logo" :error="require('@/assets/logo2.png')" />
          </el-form-item>
          <el-form-item>
            <el-button
              plain
              type="primary"
              style="margin-left:145px;background:#1E9585;border:none;color:#fff"
              @click="handleChangeLogo"
            >{{ $t('button.xg') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUpload from '@views/Imgupload'
import { GetMyInfo, UpdateMyInfo } from '@/api/Users'
import { GetLoginUserLogo, UpdateLogo } from '@/api/TV'
export default {
  components: {
    ImgUpload
  },
  data () {
    return {
      page: 'info',
      info: {

      },
      username: '',
      // readonly: false
    }
  },
  mounted () {
    this.$bus.$on('info', () => {
      this.page = 'info'
    })
    this.$bus.$on('logo', () => {
      this.page = 'logo'
    })
    this.getInfoList()
    this.getMyLogo()
  },
  // beforeDestroy () {
  //   this.$bus.$off('image')
  //   this.$bus.$off('list')
  // },
  methods: {
    // 获取我的信息（我的信息）
    getInfoList () {
      this.listLoading = true
      GetMyInfo().then(res => {
        this.info = { ...res.data }
        this.username = res.data.username
        // if (res.data.roleid === 1) {
        //   this.readonly = true
        // }
      })
    },
    // 修改我的信息（我的信息）
    onSubmit () {
      UpdateMyInfo(this.info).then(() => {
        this.info.username === '' ? this.username : this.info.username
        this.$msgSuccess(this.$t('notice.xgcg'))
        this.getInfoList()
      })
    },
    // 获取logo
    getMyLogo () {
      GetLoginUserLogo({
        id: this.$store.getters.id
      })
        .then(res => {
          this.logo = res.data.logo
        })
    },
    //  修改logo
    handleChangeLogo () {
      UpdateLogo({
        userid: this.$store.getters.id,
        base64: this.logo
      })
        .then(() => {
          this.$msgSuccess(this.$t('notice.xgcg'))
          this.$bus.$emit('logo')
        })
    }
  }
}
</script>

<style lang='stylus' scoped>
.info
  height 100%
  .filter-container
    border-radius: 5px
    height: 809px
    background: #1D3666
    .el-form
     width: 35%;
     margin: auto;
     padding-top: 140px;
     >>>.el-form-item__label
      color #1CC197
     .el-input
      // box-shadow: 0 0 2px 2px #1b9fc5
      >>>.el-input__inner
       border: 1px solid #1CC197
       background:#1D3666
       color: #fff
      >>>.el-input__prefix
       color: #fff
</style>
